export const quickReplyRoutes = {
  message: "message/:token",
  ticket: "ticket/:token",
} as const;
